<template>
  <div>
    <v-navigation-drawer v-model="drawerMenu" :width="325" absolute temporary>
      <v-btn icon @click="setDrawerMenu(false)" class="float-right mr-1 mt-2">
        <v-icon class="icon-close">mdi-close</v-icon>
      </v-btn>

      <v-list no-action class="py-0">
        <v-list-item-content class="text-center pb-0">
          <img :src="empresa.logo" class="img-empresa" width="100" />
          <span class="titulo-nome">{{ usuario.nome }}</span>
          <span class="titulo-cargo">{{ usuario.setor }}</span>

          <div class="d-flex align-center w-full pt-2 pb-3">
            <v-switch v-model="permitir_tela_cheia" class="h-10px mt-n3" dense color="#a71830">
              <template #label>
                <span class="font-12 ml-1"> Permitir tela cheia </span>
              </template>
            </v-switch>

            <v-spacer />

            <span class="font-12 text-gray-800">Versão: {{ app_version }}</span>
            <!--            <v-icon small class="cursor-pointer ml-1" @click="dialogReleaseNotes = true">mdi-help-circle</v-icon>-->
          </div>
        </v-list-item-content>
      </v-list>

      <v-divider />

      <div style="max-height: calc(100vh - 243px); overflow-y: auto">
        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title
              class="list-item"
              @click="setDialogAlterarSenha(true)"
            >
              <v-list-item-icon style="margin: 0 13% 0 0">
                <v-icon>mdi-key</v-icon>
              </v-list-item-icon
              >
              Alterar Senha
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="list-item" @click="linkDashboard">
              <v-list-item-icon style="margin: 0 13% 0 0">
                <v-icon>mdi-home</v-icon>
              </v-list-item-icon
              >
              Dashboard
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link v-if="GET_ITEMS_DRAWER.length > 0">
          <v-list-item-content>
            <v-list-item-title class="list-item" @click="linkParametrizacao">
              <v-list-item-icon style="margin: 0 12% 0 0">
                <v-icon>mdi-cogs</v-icon>
              </v-list-item-icon>
              Parametrização
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <AnaliseDeCotacoesCompraPorDepartamentos
          v-if="VERIFICAR_FLAG_DEPARTAMENTOS"
          @selecionado="drawerMenu = !drawerMenu"
        />


        <v-list>
          <v-list-group
            v-for="item in items"
            :key="item.title"
            v-model="item.active"
            :prepend-icon="item.action"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title
                  v-text="item.title"
                  class="list-item"
                ></v-list-item-title>
              </v-list-item-content>
            </template>

            <template v-for="subItem in item.items">
              <AnalisePorLote
                v-if="subItem.url === '/compras/analise-por-lotes'"
                :key="subItem.title"
                class="v-list-item v-list-item--link theme--light"
              >
                <template #ativador="{ callback }">
                  <v-list-item-content @click="callback">
                    <v-list-item-title v-text="subItem.title" class="list-item" />
                  </v-list-item-content>
                </template>
              </AnalisePorLote>

              <v-list-item v-else :key="subItem.title" @click="linkRota(subItem)">
                <v-list-item-content>
                  <v-list-item-title v-text="subItem.title" class="list-item" />
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-group>
        </v-list>
      </div>

      <v-divider />

      <v-list-item link>
        <v-list-item-content>
          <v-list-item-title class="list-item-sair" @click="exibirChatSuporte">
            <v-list-item-icon style="margin: 0 13% 0 0">
              <v-icon>mdi-lifebuoy</v-icon>
            </v-list-item-icon>
            Chat Suporte
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link>
        <v-list-item-content>
          <v-list-item-title class="list-item-sair" @click="Helpers.logout()">
            <v-list-item-icon style="margin: 0 13% 0 0">
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon
            >
            Sair
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>

    <dialog-exibe-release-notes v-model="dialogReleaseNotes" />
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex";
import UsuarioAPI from "./../../api/usuario";
import DialogExibeReleaseNotes from "../cfg/releasesNotes/DialogExibeReleaseNotes.vue"
import AnaliseDeCotacoesCompraPorDepartamentos from "../dashboard/departamentos/analiseDeCotacoes/Index"
import store from "@/store";
import AnalisePorLote from '@/components/produto/detalhes/AnalisePorLote/Index.vue';
import $axios from "@/api/api";

export default {
  components: {
    DialogExibeReleaseNotes,
    AnaliseDeCotacoesCompraPorDepartamentos,
    AnalisePorLote,
  },
  data() {
    return {
      app_version: localStorage.getItem('app_version'),
      items: [],
      dialogReleaseNotes: false,
      headers: [],
      permitir_tela_cheia: localStorage.permitir_tela_cheia === "S"
    };
  },
  computed: {
    ...mapState("app", ["empresa", "usuario"]),
    ...mapGetters({
      GET_ITEMS_DRAWER: "MenuParametrizacaoIncludes/GET_ITEMS_DRAWER",
    }),
    drawerMenu: {
      get() {
        return this.$store.state.app.drawerMenu;
      },
      set(val) {
        this.$store.commit("app/setDrawerMenu", val);
      },
    },
    VERIFICAR_FLAG_DEPARTAMENTOS() {
      return localStorage.getItem("compras_analise_por_departamentos") === 'true';
    }
  },
  watch: {
    permitir_tela_cheia() {
      localStorage.permitir_tela_cheia = this.permitir_tela_cheia ? "S" : "N"
    }
  },
  created() {
    this.getAcessos();
    this.$store.dispatch("MenuParametrizacaoIncludes/atualizarMenuParaInicial", this.$route.path);
  },
  methods: {
    exibirChatSuporte() {
      window.octadesk.chat.showApp();
      localStorage.setItem("chat_suporte_visivel", "S");
      window.dispatchEvent(new Event("chat-suporte-visibilidade-change"));

      this.drawerMenu = !this.drawerMenu;
    },

    ...mapMutations("app", ["setDrawerMenu", "setDialogAlterarSenha"]),
    linkRota(item) {
      if (item.rota) {
        this.$router.push(item.url);
      } else if (
        item.url === "relatorio_ressuprimento_abaixo" ||
        // item.url === "relatorio_ressuprimento" ||
        item.url === "relatorio_compra_materia_prima"
      ) {
        window.open($axios.defaults.baseURL + '/' + item.url, "_blank");
      } else {
        this.$emit("rRelatorio", item);
      }
    },
    getAcessos() {
      const headers = this.Helpers.iniciarRequisicao();

      UsuarioAPI.getAcessos(headers)
      .then((response) => {
        const token = response.data.token;
        localStorage.setItem("token", token);

        if (response.status === 200) {
          if (response.data.acessos.length === 0) {
            alert("Usuário sem Permissão de Acesso!!!");
            this.Helpers.logout();
          }
          this.items = [];
          this.items = response.data.acessos;
        }
      })
      .catch(() => {
        this.Helpers.logout();
      });
    },
    linkDashboard() {
      const drp = localStorage.getItem("service");

      if (drp === "S") {
        this.$router.push("/logistica");
      } else {
        this.$router.push("/dashboard");
      }
    },
    linkParametrizacao() {
      this.$router.push("/parametrizacao");
    }
  }
};
</script>

<style scoped>
.img-empresa {
  padding: 0 5% 0 5%;
}

.titulo-nome {
  color: #042333;
  font-size: 20px;
}

.titulo-cargo {
  color: #042333;
  font-size: 16px;
}

.list-item {
  color: #042333;
  font-size: 14px;
  padding-left: 0px;
}

.list-item-sair {
  color: #042333;
  font-size: 14px;
}
</style>

